import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getEnrichedAction, updateEnrichedAction } from '@wix/ambassador-nownia-action-v1-enriched-action/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { EnrichedActionClientBase } from './EnrichedActionClientBase';
export class EnrichedActionClient extends HttpBaseClient(EnrichedActionClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getEnrichedActionImpl", getEnrichedAction);
    _defineProperty(this, "updateEnrichedActionImpl", updateEnrichedAction);
  }
}
//# sourceMappingURL=EnrichedActionClientHttp.js.map